module.exports = __webpack_public_path__ + "img/icon_comentarios.0006e250.svg";